import Svg, { Defs, G, LinearGradient, Path, Stop } from 'react-native-svg'
/* SVGR has dropped some elements not supported by react-native-svg: filter */
const ErrorTxn = ({ color = '#0F3CC9' }) => (
  <Svg xmlns="http://www.w3.org/2000/svg" width={89} height={97} fill="none">
    <Path
      fill="url(#a)"
      d="M52.593 2.017c-4.655-2.69-12.279-2.69-16.932 0L8.468 17.714C3.811 20.402 0 27.002 0 32.38v31.396c0 5.377 3.811 11.976 8.468 14.666l27.193 15.697c4.653 2.688 12.277 2.688 16.932 0l27.192-15.697c4.656-2.69 8.465-9.286 8.465-14.666V32.38c0-5.377-3.81-11.976-8.466-14.666L52.593 2.017Z"
    />
    <G filter="url(#b)">
      <Path
        fill="#fff"
        d="M62.796 52.701v-8.604a3.497 3.497 0 0 0-3.497-3.497H29.61a3.497 3.497 0 0 0-3.496 3.497V52.7a3.497 3.497 0 0 0 3.497 3.497H59.3a3.497 3.497 0 0 0 3.496-3.497Z"
      />
    </G>
    <G stroke={color} strokeLinecap="round" strokeWidth={1.5}>
      <Path d="M32.085 46.242H41.3M32.085 50.675h5.642" />
    </G>
    <Path
      fill={color}
      stroke={color}
      strokeWidth={0.2}
      d="M57.337 47.02h-.841c-.077-.45-.28-.87-.584-1.21h1.426a.403.403 0 0 0 0-.805h-4.836a.403.403 0 1 0 0 .806h1.607a1.612 1.612 0 0 1 1.56 1.209h-3.167a.403.403 0 1 0 0 .806h3.167a1.612 1.612 0 0 1-1.56 1.213h-1.237a.259.259 0 0 0-.08 0l-.073.025-.06.044a.4.4 0 0 0-.06.057l-.025.025v.035a.367.367 0 0 0-.072.175v.04a.098.098 0 0 0 0 .033.264.264 0 0 0 0 .08.515.515 0 0 0 .024.073l.045.06.056.06.025.025 4.03 2.82a.41.41 0 0 0 .483-.66l-2.987-2.086a2.418 2.418 0 0 0 2.318-2.01h.841a.403.403 0 0 0 0-.806v-.01Z"
    />
    <G filter="url(#c)">
      <Path
        fill="#fff"
        d="M62.796 71.923V63.32a3.497 3.497 0 0 0-3.497-3.497H29.61a3.497 3.497 0 0 0-3.496 3.497v8.604a3.497 3.497 0 0 0 3.497 3.497H59.3a3.497 3.497 0 0 0 3.496-3.497Z"
      />
    </G>
    <G stroke={color} strokeLinecap="round" strokeWidth={1.5}>
      <Path d="M32.085 65.464H41.3M32.085 69.897h5.642" />
    </G>
    <Path
      fill={color}
      stroke={color}
      strokeWidth={0.2}
      d="M57.337 66.242h-.841c-.077-.45-.28-.87-.584-1.209h1.426a.403.403 0 1 0 0-.806h-4.836a.403.403 0 1 0 0 .806h1.607a1.612 1.612 0 0 1 1.56 1.209h-3.167a.403.403 0 0 0 0 .806h3.167a1.611 1.611 0 0 1-1.56 1.213h-1.237a.265.265 0 0 0-.08 0l-.073.025-.06.044a.405.405 0 0 0-.06.057l-.025.025v.035a.367.367 0 0 0-.072.175v.04a.097.097 0 0 0 0 .033.264.264 0 0 0 0 .08c.006.025.014.05.024.073l.045.06.056.06.025.025 4.03 2.821a.41.41 0 0 0 .483-.66l-2.987-2.087a2.418 2.418 0 0 0 2.318-2.01h.841a.403.403 0 1 0 0-.806v-.009Z"
    />
    <G filter="url(#d)">
      <Path
        fill="#fff"
        d="M62.796 33.479v-8.604a3.497 3.497 0 0 0-3.497-3.497H29.61a3.497 3.497 0 0 0-3.496 3.497v8.604a3.497 3.497 0 0 0 3.497 3.497H59.3a3.497 3.497 0 0 0 3.496-3.497Z"
      />
    </G>
    <G stroke={color} strokeLinecap="round" strokeWidth={1.5}>
      <Path d="M32.085 27.02H41.3M32.085 31.453h5.642" />
    </G>
    <Path
      fill={color}
      stroke={color}
      strokeWidth={0.2}
      d="M57.337 27.798h-.841c-.077-.45-.28-.87-.584-1.21h1.426a.403.403 0 0 0 0-.805h-4.836a.403.403 0 0 0 0 .806h1.607a1.612 1.612 0 0 1 1.56 1.209h-3.167a.403.403 0 1 0 0 .806h3.167a1.612 1.612 0 0 1-1.56 1.213h-1.237a.265.265 0 0 0-.08 0l-.073.024-.06.045a.4.4 0 0 0-.06.057l-.025.024v.036a.367.367 0 0 0-.072.175v.04a.098.098 0 0 0 0 .033.264.264 0 0 0 0 .08.516.516 0 0 0 .024.073l.045.06.056.06.025.025 4.03 2.82a.41.41 0 1 0 .483-.66l-2.987-2.086a2.418 2.418 0 0 0 2.318-2.01h.841a.403.403 0 0 0 0-.807v-.008Z"
    />
    <Defs>
      <LinearGradient id="a" x1={-1.677} x2={80.165} y1={-5.577} y2={77.429} gradientUnits="userSpaceOnUse">
        <Stop stopOpacity={0} />
        <Stop offset={1} stopColor={color} stopOpacity={0.12} />
      </LinearGradient>
    </Defs>
  </Svg>
)
export default ErrorTxn
